__turbopack_context__.v({
  "className": "jetbrains_mono_fef2546b-module__rxvAhW__className",
});
